var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopySyncedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    style: {
      enableBackground: "new 0 0 24 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24,2v18c0,1.1-0.9,2-2,2h-4v-2h4V2H8v4h8c1.1,0,2,0.9,2,2v18c0,1.1-0.9,2-2,2H6.5 c0-0.7,0.1-1.3,0.3-2H16V8H2v18h0.7c-0.1,0.7-0.2,1.3-0.2,2H2c-1.1,0-2-0.9-2-2V8c0-1.1,0.9-2,2-2h4V2c0-1.1,0.9-2,2-2c0,0,0,0,0,0 h14C23.1,0,24,0.9,24,2C24,2,24,2,24,2z M5,16.3v2h3C6.1,19.9,3.5,23,3.5,29h2c0-5.6,2.6-8.3,4.2-9.4V23h2v-6.7L5,16.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySyncedIcon);
export default __webpack_public_path__ + "static/media/copy-synced-icon.86037622.svg";
export { ForwardRef as ReactComponent };